// * Bootstrap libraries
import './_bootstrap';
import 'material-symbols';


// * Any other global site-wide JavaScript should be placed below.
// CUSTOM JS
/**
 * @file
 * Theme js.
 */
(function ($, Drupal, drupalSettings, once) {
    'use strict';


// MIS FUNCIONES:::::::::::::::
/**
* CLASE PARA DIFERENCIAR MENU DESKTOP / MOBILE
*
*/
function mainMenuResize() {
  //------------------------ MENU ESCRITORIO/MOVIL
  $(".navbar-nav").addClass("menu-desktop");
  if (window.innerWidth < 992){
    $(".navbar-nav").removeClass("menu-desktop");
    $(".navbar-nav").addClass("menu-mobile");
  }
  $(window).resize(function(){
    if (window.innerWidth < 992){
      $(".navbar-nav").addClass("menu-mobile");
      $(".navbar-nav").removeClass("menu-desktop");
    }else{
      $(".navbar-nav").removeClass("menu-mobile");
      $(".navbar-nav").addClass("menu-desktop");
    }
  });
  $(".nav-link").click(function (e) {
    $(".block-globo").removeClass("active");// reactivo el globo idioma
    $(".block-lupa").removeClass("active");// reactivo la lupa
  });
}
//------------------------- FIN MENU ESCRIOTIO/MOVIL


/**
* bUSCADOR DE CABECERA DESPLEGABLE
*
*/
function searchMain() {
  // Al hacer clic en el icono de la lupa
  $('.block-lupa').click(function (e) {
    e.stopPropagation(); // Prevenir propagación del evento
    $(this).toggleClass("active");
    $(".block-globo").removeClass("active");// reactivo el globo idioma
    const $searchWrap = $(".search-wrap");
    const isVisible = $searchWrap.is(":visible");
    // Mostrar u ocultar el buscador
    $searchWrap.toggle();
    // Si el buscador ahora está visible, cerrar menús desplegables
    if (!isVisible) {
      $(".dropdown-menu.show").removeClass("show");
    }
    if ($(window).width() < 992) {
      $(".navbar-collapse.show").removeClass("show");
      $(".navbar-toggler").addClass("collapsed");// para cambiar burger
    }
    $(".block_menu_idioma-region").hide(); // cierro el menu Idiomas
  });
  // Evitar que los clics dentro del buscador cierren el contenedor
  $(".search-wrap").click(function (e) {
    e.stopPropagation();
  });
  // Cerrar el buscador al hacer clic fuera de él
  $(document).click(function () {
    $(".search-wrap").hide();
    $(this).removeClass("active");
    $(".block-lupa").removeClass("active");// reactivo la lupa
  });
}
//-- FIN


/**
* dESPLEGABLE MENÚ IDIOMA / REGIÓN
*
*/

function menuRegion() {
  $('.block-globo').click(function (e) {
    e.stopPropagation(); // Prevenir propagación del evento
    $(this).toggleClass("active");
    $(".block-lupa").removeClass("active");// reactivo la lupa
    const $searchWrap = $(".block_menu_idioma-region");
    const isVisible = $searchWrap.is(":visible");
    
    // Mostrar u ocultar el buscador
    $searchWrap.toggle();
    
    // Si este menu ahora está visible, cerrar menús desplegables EXCEPTO los del menú territorios
    if (!isVisible) {
      $(".dropdown-menu.show").not(".block_menu_idioma-region .dropdown-menu").removeClass("show");
    }
    
    if ($(window).width() < 992) {
      $(".navbar-collapse.show").removeClass("show");
      $(".navbar-toggler").addClass("collapsed");// para cambiar burger
    }
    
    $(".search-wrap").hide(); // cierro el buscador
    
    // Después de mostrar el menú, mantener abiertos los últimos 2 dropdowns
    setTimeout(function() {
      keepTerritoriosDropdownsOpen();
      disableCurrentLanguageLinks();
    }, 50);
  });

  // Evitar que los clics dentro del menu cierren el contenedor
  $(".block_menu_idioma-region").click(function (e) {
    e.stopPropagation();
  });

  // Cerrar el menu al hacer clic fuera de él
  $(document).click(function () {
    $(".block_menu_idioma-region").hide();
    $(this).removeClass("active");
    $(".block-globo").removeClass("active");// reactivo el globo idioma
  });

  // Función para mantener abiertos los dropdowns de territorios
  function keepTerritoriosDropdownsOpen() {
    // Seleccionar los últimos 2 elementos dropdown del menú territorios
    const $territoryDropdowns = $(".block_menu_idioma-region .nav-item.dropdown");
    
    //if ($territoryDropdowns.length >= 2) {
      // Obtener los últimos 2 elementos
      //const $lastTwo = $territoryDropdowns.slice(-2);
      
      // Agregar las clases necesarias para mantenerlos abiertos
      $territoryDropdowns.find('.dropdown-menu').addClass('show');
      $territoryDropdowns.find('.dropdown-toggle').addClass('show').attr('aria-expanded', 'true');
    //}
  }

  // Función para deshabilitar el enlace del idioma actual
  function disableCurrentLanguageLinks() {
    // Detectar idioma actual de la página
    const currentLang = $('html').attr('lang') || 'es';
    
    // Solo buscar en enlaces principales (nav-link), NO en dropdown-item
    $(".block_menu_idioma-region .nav-link").each(function() {
      const linkText = $(this).text().toLowerCase();
      let isCurrentLanguage = false;
      
      // Detectar si es el enlace del idioma actual - SOLO enlaces principales
      if (currentLang === 'en' && linkText.includes('global') && linkText.includes('english')) {
        isCurrentLanguage = true;
      } else if (currentLang === 'es' && linkText.includes('españa') && linkText.includes('español')) {
        isCurrentLanguage = true;
      } else if (currentLang === 'es-cl' && linkText.includes('chile') && linkText.includes('español')) {
        isCurrentLanguage = true;
      }
      
      // Si es el idioma actual, deshabilitarlo
      if (isCurrentLanguage) {
        $(this).addClass('disabled current-language');
        $(this).css({
          'opacity': '0.6',
          'pointer-events': 'none',
          'cursor': 'default',
          'color': '#6c757d !important'
        });
      }
    });
  }

  // Mantener abiertos los dropdowns al cargar la página
  $(document).ready(function() {
    keepTerritoriosDropdownsOpen();
    disableCurrentLanguageLinks();
  });

  // Prevenir que Bootstrap cierre automáticamente estos dropdowns específicos
  $(document).on('hide.bs.dropdown', '.block_menu_idioma-region .nav-item.dropdown', function(e) {
    // Verificar si es uno de los últimos 2 dropdowns
    const $allDropdowns = $(".block_menu_idioma-region .nav-item.dropdown");
    //const $lastTwo = $allDropdowns.slice(-2);
    
    if ($allDropdowns.is($(this))) {
      e.preventDefault(); // Prevenir que se cierre
      return false;
    }
  });
}
//-- FIN


/**
* LITERAL MENÚ IDIOMA / REGIÓN
*
*/
function literalRegion(){
  // Obtiene el path del idioma desde la URL
  var path = window.location.pathname;
    
  // Ajustar prefijos según los idiomas configurados en el sitio
  var idioma = 'es'; // Idioma por defecto
  if (path.startsWith('/en')) {
    idioma = 'en';
  } else if (path.startsWith('/es-cl')) {
    idioma = 'es_cl'; // Chile
  } else if (path.startsWith('/eu')) {
    idioma = 'eu'; // Euskera
  }

  // Define los textos según idioma
  var textos = {
    es: 'Español',
    en: 'English',
    es_cl: 'Chile (Español)',
    eu: 'Euskera',
  };

  // Cambia el texto del div
  $('.texto-globo').text(textos[idioma]);
}

/**
* EFECTO PARA MOSTRAR RESUMEN EN CARDS DE BLOGS
*
*/
function showSummary() {
  $('.articulo')
    .on('mouseenter focusin', function () {
      $(this).find('.articulo-resumen').fadeIn();
    })
    .on('mouseleave focusout', function () {
      $(this).find('.articulo-resumen').fadeOut();
    });
}



/**
* EFECTO PARA MENÚ SECUNDARIO DE ANCLAS
*
*/
function slideMenuAnclas() {
  const $submenu = $('nav.submenu-anclas-nav');
  const $navbar = $('.navbar');

  if ($submenu.length === 0 || $navbar.length === 0) return;

  const submenuInitialOffset = $submenu.offset().top;
  const navbarHeight = $navbar.outerHeight();

  $(window).on('scroll resize', function () {
    const scrollTop = $(this).scrollTop();
    const windowWidth = $(window).width();

    // Solo aplicar en escritorio (ejemplo: >= 768px)
    if (windowWidth >= 720) {
      if (scrollTop + navbarHeight >= submenuInitialOffset) {
        if (!$submenu.hasClass('is-fixed')) {
          $submenu.addClass('is-fixed');
          $submenu.css({
            position: 'fixed',
            top: navbarHeight + 'px',
            width: $submenu.parent().width() + 'px',
            zIndex: 5
          });
        }
      } else {
        if ($submenu.hasClass('is-fixed')) {
          $submenu.removeClass('is-fixed');
          $submenu.css({
            position: '',
            top: '',
            width: '',
            zIndex: ''
          });
        }
      }
    } else {
      // En móvil, asegurarse de que nunca quede fijo
      if ($submenu.hasClass('is-fixed')) {
        $submenu.removeClass('is-fixed');
        $submenu.css({
          position: '',
          top: '',
          width: '',
          zIndex: ''
        });
      }
    }
  });
}



/**
* EFECTO PARA DESPLAZAMIENTO DE ANCLAS
*
*/
function ajustarAnclasConMargen() {
  const offsetClase = 'ancla-ajustada';

  $('.submenu-anclas-nav a.nav-link[href^="#"]').on('click', function (e) {
    const href = $(this).attr('href');
    if (!href || href === '#') return;

    const $target = $(href);
    if ($target.length) {
      // Aseguramos que tenga la clase que le da margen superior
      if (!$target.hasClass(offsetClase)) {
        $target.addClass(offsetClase);
      }
    }
  });
}


/**
 * Ajusta la altura de PARAGRAPH bloque-imagen a la de bloque-texto
 */
function ajustarAlturaImagen() {
  const bloques = document.querySelectorAll('.paragraph_image-text');

  bloques.forEach((bloque) => {
    const bloqueTexto = bloque.querySelector('.bloque-texto');
    const bloqueImagen = bloque.querySelector('.bloque-imagen');

    if (bloqueTexto && bloqueImagen) {
      bloqueImagen.style.height = bloqueTexto.offsetHeight + 'px';
    }
  });
}
// Ejecutar cuando cargue la página
window.addEventListener('load', ajustarAlturaImagen);
// Recalcular al cambiar tamaño de ventana
window.addEventListener('resize', ajustarAlturaImagen);


// FUNCION PARA POSICIONAMIENTO RRSS DEL FOOTER
const $rrss = $(".block_rrss_footer");
const $originalParent = $rrss.parent();
const $originalNext = $rrss.next();
function moveRRSS() {
  if (window.matchMedia("(min-width: 720px)").matches) {
    // Escritorio → mover después del menú
    $rrss.insertAfter(".block_footer_menu .block__content ul.nav");
  } else {
    // Móvil → devolver a su sitio original
    if ($originalNext.length) {
      $rrss.insertBefore($originalNext);
    } else {
      $rrss.appendTo($originalParent);
    }
  }
}
$(document).ready(moveRRSS);
$(window).resize(moveRRSS);


function fixMenuWidthOnBold() {
  jQuery('.navbar-nav.menu-desktop .nav-link').each(function () {
    var $link = jQuery(this);

    // Quitar ancho anterior para recalcular correctamente
    $link.css('width', 'auto');

    // Medir ancho actual en font-weight normal
    var currentWidth = $link.outerWidth();

    // Fijar el ancho exacto en píxeles
    $link.css({
      'display': 'inline-block',
      'width': currentWidth + 'px',
      'text-align': 'center'
    });
  });
}
$(document).ready(fixMenuWidthOnBold);
$(window).resize(fixMenuWidthOnBold);


//::::::::::::::::::::::::::::::::::::::::::::::::::
//          ENTRADA DE EJECUCION PRINCIPAL
//::::::::::::::::::::::::::::::::::::::::::::::::::
Drupal.behaviors.altiaRadixMain = {
  attach(context, settings) {
    once('altiaRadixMain', 'body', context).forEach(function () {
      // Esperamos hasta que exista el toolbar
      const check = () => {
        if (document.querySelector('.navbar-nav')) {
          mainMenuResize(); // -- funcion para direfenciar menú móbil de menú escritorio
          searchMain();     // -- funcion para desplegar buscador de cabecera
          menuRegion();     // -- funcion para desplegar menú idioma
          literalRegion();  // -- funcion para cambiar literal del menú idioma
          showSummary();    // -- función para efecto HOVER de las Card de Blog
          slideMenuAnclas();// -- funcion para efecto slide en menú secundario de Anclas
          ajustarAnclasConMargen(); //-- funcion que permite desplazar las anclas para que estén siempre visibles
          moveRRSS(); //-- funcion para posicionamiento de RRSS del footer

        } else {
          // Si aún no está, espera y vuelve a intentar
          setTimeout(check, 100);
        }
      };
      check();
    });
  }
};
//::::::::::::::::::::::::::::::::::::::::::::::::::
//::::::::::::::::::::::::::::::::::::::::::::::::::


})(jQuery, Drupal, drupalSettings, once);